var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrap",staticClass:"img-zoom-wrapper"},[_c('zoom-on-hover',{key:`${_vm.src}-${_vm.resolvedScale}`,staticClass:"zoom-container",attrs:{"img-normal":_vm.src,"img-zoom":_vm.zoomSrc || _vm.src,"scale":_vm.resolvedScale}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }